export default function inkjetticketGenerator(data) {
  return `
   <!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta http-equiv="X-UA-Compatible" content="IE=edge">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <style>
   a,
   button,
   input,
   select,
   h1,
   h2,
   h3,
   h4,
   h5,
   * {
       box-sizing: border-box;
       margin: 0;
       padding: 0;
       border: none;
       text-decoration: none;
       background: none;
   
       -webkit-font-smoothing: antialiased;
   }
   
   menu, ol, ul {
       list-style-type: none;
       margin: 0;
       padding: 0;
   }
   .frame-1,
.frame-1 * {
  box-sizing: border-box;
}
.frame-1 {
  background: #ffffff;
  height: 760px;
  position: relative;
  overflow: hidden;
}
.flete {
  color: #000000;
  text-align: left;
  font-family: "InknutAntiqua-Bold", sans-serif;
  font-size: 10px;
  letter-spacing: 0.01em;
  font-weight: 700;
  position: absolute;
  left: 666px;
  top: 285px;
}
  
.seguro {
  color: #000000;
  text-align: left;
  font-family: "InknutAntiqua-Bold", sans-serif;
  font-size: 10px;
  letter-spacing: 0.01em;
  font-weight: 700;
  position: absolute;
  left: 830px;
  top: 285px;
}
.pais-origen {
  color: #000000;
  text-align: left;
  font-family: "InknutAntiqua-Bold", sans-serif;
  font-size: 10px;
  letter-spacing: 0.01em;
  font-weight: 700;
  position: absolute;
  left: 666px;
  top: 245px;
}
.pais-destino {
  color: #000000;
  text-align: left;
  font-family: "InknutAntiqua-Bold", sans-serif;
  font-size: 10px;
  letter-spacing: 0.01em;
  font-weight: 700;
  position: absolute;
  left: 666px;
  top: 264px;
}
.furgon-placa {
  color: #000000;
  text-align: left;
  font-family: "InknutAntiqua-Bold", sans-serif;
  font-size: 10px;
  letter-spacing: 0.01em;
  font-weight: 700;
  position: absolute;
  left: 666px;
  top: 225px;
  width: 117px;
  height: 25px;
}
.line-1 {
  margin-top: -1px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px 0 0 0;
  width: 699px;
  height: 0px;
  position: absolute;
  left: 14px;
  top: 727px;
  transform-origin: 0 0;
  transform: rotate(-89.918deg) scale(1, 1);
}
.line-4 {
  margin-top: -1px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px 0 0 0;
  width: 595px;
  height: 0px;
  position: absolute;
  left: 34px;
  top: 152px;
  transform-origin: 0 0;
  transform: rotate(0.193deg) scale(1, 1);
}
.line-3 {
  margin-top: -1px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px 0 0 0;
  width: 972px;
  height: 0px;
  position: absolute;
  left: 15px;
  top: 29px;
  transform-origin: 0 0;
  transform: rotate(0deg) scale(1, 1);
}
.line-6 {
  margin-top: -1px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px 0 0 0;
  width: 595px;
  height: 0px;
  position: absolute;
  left: 34px;
  top: 204px;
  transform-origin: 0 0;
  transform: rotate(-0.193deg) scale(1, 1);
}
.line-11 {
  margin-top: -1px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px 0 0 0;
  width: 594px;
  height: 0px;
  position: absolute;
  left: 34px;
  top: 178px;
  transform-origin: 0 0;
  transform: rotate(0deg) scale(1, 1);
}
.line-7 {
  margin-top: -1px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px 0 0 0;
  width: 594.01px;
  height: 0px;
  position: absolute;
  left: 35px;
  top: 239px;
  transform-origin: 0 0;
  transform: rotate(0.289deg) scale(1, 1);
}
.line-8 {
  margin-top: -1px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px 0 0 0;
  width: 594px;
  height: 0px;
  position: absolute;
  left: 34px;
  top: 264px;
  transform-origin: 0 0;
  transform: rotate(0deg) scale(1, 1);
}
.line-9 {
  margin-top: -1px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px 0 0 0;
  width: 595px;
  height: 0px;
  position: absolute;
  left: 33px;
  top: 304px;
  transform-origin: 0 0;
  transform: rotate(-0.096deg) scale(1, 1);
}
.transportes-el-salvador {
    color: #000000;
    text-align: center;
    font-family: "InknutAntiqua-Bold", sans-serif;
    font-size: 20px;
    letter-spacing: 0.01em;
    font-weight: 700;
    position: absolute;
    left: 345px;
    width: 384px; /* Puedes mantenerlo */
    white-space: normal; /* Permite saltos */
    word-wrap: break-word; /* Rompe palabras largas */
    overflow-wrap: break-word; /* Compatibilidad */
}

.carta-de-porte-no {
  color: #000000;
  text-align: left;
  font-family: "InknutAntiqua-Bold", sans-serif;
  font-size: 13px;
  letter-spacing: 0.01em;
  font-weight: 700;
  position: absolute;
  left: 720px;
  top: 95px;
  width: 175px;
  height: 50px;
}
.kilometro-20-5-calle-poniente-y-25-avenida-sur-san-jose-del-monte-interseccion-las-ca-as-1 {
    color: #000000;
    text-align: center;
    font-family: "Inder-Regular", sans-serif;
    font-size: 10px;
    letter-spacing: 0.01em;
    font-weight: 400;
    position: absolute;
    left: 380px;
    top: 69px;
    width: 320px;
    height: 15px;
}
._001 {
  color: #ff0000;
  text-align: left;
  font-family: "Inder-Regular", sans-serif;
  font-size: 13px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
  left: 880px;
  top: 95px;
  width: 46px;
  height: 36px;
}
.cs-cajas-bs-bolsas-pts-paquetes-u-unidades-sa-sacos-ro-rollos {
  color: #ff0000;
  text-align: left;
  font-family: "Inder-Regular", sans-serif;
  font-size: 13px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
  left: 260px;
  top: 603px;
  width: 570px;
  height: 18px;
}
.eduardo-antonio-marroquin-orellana {
  color: #003366;
  text-align: left;
  font-family: "Inder-Regular", sans-serif;
  font-size: 14px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
  left: 380px;
  top: 685px;
  width: 254px;
  height: 18px;
  text-align: center;
}
.line-10 {
  margin-top: -1px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px 0 0 0;
 width: 151px;
  height: 0px;
  position: absolute;
  left: 260px;
  top: 152px;
  transform-origin: 0 0;
  transform: rotate(90.377deg) scale(1, 1);
}
.line-15 {
  margin-top: -1px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px 0 0 0;
  width: 152px;
  height: 0px;
  position: absolute;
  left: 34px;
  top: 152px;
  transform-origin: 0 0;
  transform: rotate(90deg) scale(1, 1);
}
.line-12 {
  margin-top: -1px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px 0 0 0;
  width: 24px;
  height: 0px;
  position: absolute;
  left: 457px;
  top: 154px;
  transform-origin: 0 0;
  transform: rotate(90deg) scale(1, 1);
}
.lugar-y-fecha-de-expedici-n {
  color: #000000;
  text-align: left;
  font-family: "InknutAntiqua-Bold", sans-serif;
  font-size: 10px;
  letter-spacing: 0.01em;
  font-weight: 700;
  position: absolute;
  left: 38px;
  top: 157px;
  width: 219px;
  height: 25px;
}
.codigo-de-transportista {
  color: #000000;
  text-align: left;
  font-family: "InknutAntiqua-Bold", sans-serif;
  font-size: 10px;
  letter-spacing: 0.01em;
  font-weight: 700;
  position: absolute;
  left: 665px;
  top: 131px;
  width: 193px;
  height: 25px;
}
.piloto {
  color: #000000;
  text-align: left;
  font-family: "InknutAntiqua-Bold", sans-serif;
  font-size: 10px;
  letter-spacing: 0.01em;
  font-weight: 700;
  position: absolute;
  left: 666px;
  top: 158px;
  width: 54px;
  height: 25px;
  
}
.licencia-piloto {
  color: #000000;
  text-align: left;
  font-family: "InknutAntiqua-Bold", sans-serif;
  font-size: 10px;
  letter-spacing: 0.01em;
  font-weight: 700;
  position: absolute;
  left: 665px;
 top: 183px;
  width: 117px;
  height: 25px;
}
.cabezal-placa {
  color: #000000;
  text-align: left;
  font-family: "InknutAntiqua-Bold", sans-serif;
  font-size: 10px;
  letter-spacing: 0.01em;
  font-weight: 700;
  position: absolute;
  left: 665px;
  top: 205px;
  width: 117px;
  height: 25px;
}
.san-salvador {
  color: #1f4c78;
  text-align: left;
  font-family: "Inder-Regular", sans-serif;
  font-size: 14px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
  left: 263px;
  top: 155px;
  height: 25px;
}
.industrias-alas-verdes-s-a-de-c-v {
  color: #1f4c78;
  text-align: left;
  font-family: "Inder-Regular", sans-serif;
  font-size: 14px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
  left: 263px;
  top: 181px;
  width: 360px;
  height: 25px;
}
.km-34-boulevard-del-ejercito-nacional-y-10-ave-norte-barrio-la-ceiba {
  color: #1f4c78;
  text-align: left;
  font-family: "Inder-Regular", sans-serif;
  font-size: 14px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
  left: 263px;
  top: 205px;
  width: 367px;
  height: 36px;
}
.industrias-de-costa-rica {
  color: #1f4c78;
  text-align: left;
  font-family: "Inder-Regular", sans-serif;
  font-size: 14px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
  left: 263px;
  top: 242px;
  height: 25px;
}
.avenida-san-juan-y-calle-sur-no-2034-san-jose-costa-rica {
  color: #1f4c78;
  text-align: left;
  font-family: "Inder-Regular", sans-serif;
  font-size: 14px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
  left: 263px;
  top: 266px;
  width: 370px;
  height: 41px;
}
._20-de-diciembre-de-2020 {
  color: #1f4c78;
  text-align: left;
  font-family: "Inder-Regular", sans-serif;
  font-size: 14px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
      left: 476px;
  top: 158px;
}
.consignatario {
  color: #000000;
  text-align: left;
  font-family: "InknutAntiqua-Bold", sans-serif;
  font-size: 10px;
  letter-spacing: 0.01em;
  font-weight: 700;
  position: absolute;
  left: 38px;
  top: 245px;
  width: 219px;
  height: 25px;
}
.direcci-n-del-consignatario {
  color: #000000;
  text-align: left;
  font-family: "InknutAntiqua-Bold", sans-serif;
  font-size: 10px;
  letter-spacing: 0.01em;
  font-weight: 700;
  position: absolute;
  left: 38px;
  top: 275px;
  width: 219px;
  height: 25px;
}
.direcci-n-del-exportador {
  color: #000000;
  text-align: left;
  font-family: "InknutAntiqua-Bold", sans-serif;
  font-size: 10px;
  letter-spacing: 0.01em;
  font-weight: 700;
  position: absolute;
  left: 38px;
  top: 215px;
  width: 219px;
  height: 25px;
}
.exportador {
  color: #000000;
  text-align: left;
  font-family: "InknutAntiqua-Bold", sans-serif;
  font-size: 10px;
  letter-spacing: 0.01em;
  font-weight: 700;
  position: absolute;
  left: 38px;
  top: 185px;
  width: 219px;
  height: 21px;
}
.captura-de-pantalla-20250104-104626-1 {
  width: 90px;
  height: 106px;
  position: absolute;
  left: 70px;
  top: 40px;
  object-fit: cover;
}
.line-16 {
  margin-top: -1px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px 0 0 0;
  width: 179px;
  height: 0px;
  position: absolute;
  left: 972px;
  top: 124px;
  transform-origin: 0 0;
  transform: rotate(90deg) scale(1, 1);
}
.line-13 {
  margin-top: -1px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px 0 0 0;
  width: 150px;
  height: 0px;
  position: absolute;
  left: 629px;
  top: 153px;
  transform-origin: 0 0;
  transform: rotate(90.372deg) scale(1, 1);
}
.line-17 {
  margin-top: -1px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px 0 0 0;
  width: 26.96px;
  height: 0px;
  position: absolute;
  left: 850.06px;
  top: 125px;
  transform-origin: 0 0;
  transform: rotate(90.136deg) scale(1, 1);
}
.line-18 {
  margin-top: -1px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px 0 0 0;
  width: 26px;
  height: 0px;
  position: absolute;
  left: 717px;
  top: 152px;
  transform-origin: 0 0;
  transform: rotate(90deg) scale(1, 1);
}
.line-19 {
  margin-top: -1px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px 0 0 0;
  width: 309px;
  height: 0px;
  position: absolute;
  left: 972px;
  top: 124px;
  transform-origin: 0 0;
  transform: rotate(179.815deg) scale(1, 1);
}
.line-20 {
  margin-top: -1px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px 0 0 0;
  width: 178px;
  height: 0px;
  position: absolute;
  left: 662px;
  top: 303px;
  transform-origin: 0 0;
  transform: rotate(-89.678deg) scale(1, 1);
}
.rectangle-5 {
  background: #ffffff;
  border-style: solid;
  border-color: #000000;
  border-width: 1px;
  width: 938px;
  height: 282px;
  position: absolute;
  left: 35px;
  top: 316px;
}
.rectangle-7 {
  background: #ccffff;
  width: 291.20px;
  height: 280px;
  position: absolute;
  left: 680px;
  top: 317px;
}
.line-21 {
  margin-top: -1px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px 0 0 0;
  width: 937px;
  height: 0px;
  position: absolute;
  left: 35px;
  top: 341px;
  transform-origin: 0 0;
  transform: rotate(0deg) scale(1, 1);
}
.line-27 {
  margin-top: -1px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px 0 0 0;
  width: 937px;
  height: 0px;
  position: absolute;
  left: 35px;
  top: 366px;
  transform-origin: 0 0;
  transform: rotate(-0.061deg) scale(1, 1);
}
.line-28 {
  margin-top: -1px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px 0 0 0;
  width: 937px;
  height: 0px;
  position: absolute;
  left: 35px;
  top: 390px;
  transform-origin: 0 0;
  transform: rotate(-0.061deg) scale(1, 1);
}
.line-29 {
  margin-top: -1px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px 0 0 0;
  width: 937px;
  height: 0px;
  position: absolute;
  left: 35px;
  top: 414px;
  transform-origin: 0 0;
  transform: rotate(0deg) scale(1, 1);
}
.line-30 {
  margin-top: -1px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px 0 0 0;
  width: 937px;
  height: 0px;
  position: absolute;
  left: 35px;
  top: 439px;
  transform-origin: 0 0;
  transform: rotate(0deg) scale(1, 1);
}
.line-31 {
  margin-top: -1px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px 0 0 0;
  width: 937px;
  height: 0px;
  position: absolute;
  left: 35px;
  top: 465px;
  transform-origin: 0 0;
  transform: rotate(0deg) scale(1, 1);
}
.bs {
  color: #1f4c78;
  text-align: center;
  font-family: "Inder-Regular", sans-serif;
  font-size: 12px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
  left: 212px;
  top: 497px;
  width: 30px;
  height: 15px;
}
.line-32 {
  margin-top: -1px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px 0 0 0;
  width: 937px;
  height: 0px;
  position: absolute;
  left: 35px;
  top: 492px;
  transform-origin: 0 0;
  transform: rotate(0deg) scale(1, 1);
}
.line-33 {
  margin-top: -1px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px 0 0 0;
  width: 937px;
  height: 0px;
  position: absolute;
  left: 35px;
  top: 517px;
  transform-origin: 0 0;
  transform: rotate(0deg) scale(1, 1);
}
.line-34 {
  margin-top: -1px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px 0 0 0;
  width: 937px;
  height: 0px;
  position: absolute;
  left: 35px;
  top: 544px;
  transform-origin: 0 0;
  transform: rotate(0deg) scale(1, 1);
}
.line-35 {
  margin-top: -1px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px 0 0 0;
  width: 937px;
  height: 0px;
  position: absolute;
  left: 35px;
  top: 570px;
  transform-origin: 0 0;
  transform: rotate(0deg) scale(1, 1);
}
.line-36 {
  margin-top: -1px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px 0 0 0;
  width: 938px;
  height: 0px;
  position: absolute;
  left: 34px;
  top: 644px;
  transform-origin: 0 0;
  transform: rotate(0deg) scale(1, 1);
}
.line-37 {
  margin-top: -1px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px 0 0 0;
  width: 972px;
  height: 0px;
  position: absolute;
  left: 14px;
  top: 727px;
  transform-origin: 0 0;
  transform: rotate(0.059deg) scale(1, 1);
}
.line-22 {
  margin-top: -1px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px 0 0 0;
  width: 281px;
  height: 0px;
  position: absolute;
  left: 210px;
  top: 317px;
  transform-origin: 0 0;
  transform: rotate(90.204deg) scale(1, 1);
}
.line-23 {
  margin-top: -1px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px 0 0 0;
  width: 281.01px;
  height: 0px;
  position: absolute;
  left: 306px;
  top: 317px;
  transform-origin: 0 0;
  transform: rotate(90.408deg) scale(1, 1);
}
.bs2 {
  color: #1f4c78;
  text-align: center;
  font-family: "Inder-Regular", sans-serif;
  font-size: 12px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
  left: 213px;
  top: 369px;
  width: 30px;
  height: 15px;
}
.bs3 {
  color: #1f4c78;
  text-align: center;
  font-family: "Inder-Regular", sans-serif;
  font-size: 12px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
  left: 213px;
  top: 393px;
  width: 30px;
  height: 15px;
}
.line-25 {
  margin-top: -1px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px 0 0 0;
  width: 257px;
  height: 0px;
  position: absolute;
  left: 247px;
  top: 341px;
  transform-origin: 0 0;
  transform: rotate(90.223deg) scale(1, 1);
}
.line-24 {
  margin-top: -1px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px 0 0 0;
  width: 281px;
  height: 0px;
  position: absolute;
  left: 681px;
  top: 317px;
  transform-origin: 0 0;
  transform: rotate(90deg) scale(1, 1);
}
.line-26 {
  margin-top: -1px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px 0 0 0;
  width: 281px;
  height: 0px;
  position: absolute;
  left: 830px;
  top: 317px;
  transform-origin: 0 0;
  transform: rotate(89.796deg) scale(1, 1);
}
.facturas {
  color: #000000;
  text-align: left;
  font-family: "InknutAntiqua-Bold", sans-serif;
  font-size: 10px;
  letter-spacing: 0.01em;
  font-weight: 700;
  position: absolute;
  left: 88px;
  top: 323px;
  width: 69px;
  height: 25px;
}
.no-de-bultos {
  color: #000000;
  text-align: left;
  font-family: "InknutAntiqua-Bold", sans-serif;
  font-size: 10px;
  letter-spacing: 0.01em;
  font-weight: 700;
  position: absolute;
  left: 220px;
  top: 323px;
  width: 81px;
  height: 25px;
}
.contenido {
  color: #000000;
  text-align: left;
  font-family: "InknutAntiqua-Bold", sans-serif;
  font-size: 10px;
  letter-spacing: 0.01em;
  font-weight: 700;
  position: absolute;
  left: 451px;
  top: 323px;
  width: 81px;
  height: 25px;
}
.totales {
  color: #003366;
  text-align: left;
  font-family: "InknutAntiqua-Bold", sans-serif;
  font-size: 10px;
  letter-spacing: 0.01em;
  font-weight: 700;
  position: absolute;
  left: 453px;
  top: 577px;
  width: 59px;
  height: 19px;
}
.piloto2 {
  color: #000000;
  text-align: left;
  font-family: "InknutAntiqua-Bold", sans-serif;
  font-size: 10px;
  letter-spacing: 0.01em;
  font-weight: 700;
  position: absolute;
  left: 467px;
  top: 703px;
  width: 49px;
  height: 19px;
}
.piloto3 {
  color: #000000;
  text-align: left;
  font-family: "InknutAntiqua-Bold", sans-serif;
  font-size: 10px;
  letter-spacing: 0.01em;
  font-weight: 700;
  position: absolute;
  left: 855px;
  top: 703px;
  width: 49px;
  height: 19px;
}
.observaciones {
  color: #000000;
  text-align: left;
  font-family: "InknutAntiqua-Bold", sans-serif;
  font-size: 10px;
  letter-spacing: 0.01em;
  font-weight: 700;
  position: absolute;
  left: 35px;
  top: 614px;
  width: 129px;
  height: 19px;
}
.line-38 {
  margin-top: -1px;
  border-style: solid;
  border-color: rgba(0, 0, 0, 0);
  border-width: 1px 0 0 0;
  width: 269px;
  height: 0px;
  position: absolute;
  left: 703px;
  top: 181px;
  transform-origin: 0 0;
  transform: rotate(-0.217deg) scale(1, 1);
}
.line-39 {
  margin-top: -1px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px 0 0 0;
  width: 310px;
  height: 0px;
  position: absolute;
  left: 663px;
  top: 152px;
  transform-origin: 0 0;
  transform: rotate(0.185deg) scale(1, 1);
}
.line-40 {
  margin-top: -1px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px 0 0 0;
  width: 310px;
  height: 0px;
  position: absolute;
  left: 662px;
  top: 242px;
  transform-origin: 0 0;
  transform: rotate(0deg) scale(1, 1);
}
.line-44 {
  margin-top: -1px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px 0 0 0;
  width: 310px;
  height: 0px;
  position: absolute;
  left: 662px;
  top: 281px;
  transform-origin: 0 0;
  transform: rotate(0.185deg) scale(1, 1);
}
.line-41 {
  margin-top: -1px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px 0 0 0;
  width: 310.01px;
  height: 0px;
  position: absolute;
  left: 663px;
  top: 178px;
  transform-origin: 0 0;
  transform: rotate(0.371deg) scale(1, 1);
}
.line-42 {
  margin-top: -1px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px 0 0 0;
  width: 311px;
  height: 0px;
  position: absolute;
  left: 662px;
  top: 201px;
  transform-origin: 0 0;
  transform: rotate(0.184deg) scale(1, 1);
}
.line-43 {
  margin-top: -1px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px 0 0 0;
  width: 311px;
  height: 0px;
  position: absolute;
  left: 662px;
  top: 223px;
  transform-origin: 0 0;
  transform: rotate(-0.018deg) scale(1, 1);
}
.line-45 {
  margin-top: -1px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px 0 0 0;
  width: 63px;
  height: 0px;
  position: absolute;
  left: 782px;
  top: 179px;
  transform-origin: 0 0;
  transform: rotate(90deg) scale(1, 1);
}
.line-48 {
  margin-top: -1px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px 0 0 0;
  width: 21px;
  height: 0px;
  position: absolute;
  left: 720px;
  top: 281px;
  transform-origin: 0 0;
  transform: rotate(90deg) scale(1, 1);
}
.line-49 {
  margin-top: -1px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px 0 0 0;
  width: 311px;
  height: 0px;
  position: absolute;
  left: 662px;
  top: 303px;
  transform-origin: 0 0;
  transform: rotate(0deg) scale(1, 1);
}
.div {
  color: #1f4c78;
  text-align: right;
  font-family: "InknutAntiqua-Bold", sans-serif;
  font-size: 14px;
  letter-spacing: 0.01em;
  font-weight: 700;
  position: absolute;
  left: 734px;
  top: 273px;
  width: 89px;
  height: 12px;
}
  .div5 {
  color: #1f4c78;
  text-align: left;
  font-family: "InknutAntiqua-Bold", sans-serif;
  font-size: 14px;
  letter-spacing: 0.01em;
  font-weight: 700;
  position: absolute;
  left: 721px;
  top: 284px;
  width: 10px;
  height: 12px;
}
  .div6 {
  color: #1f4c78;
  text-align: left;
  font-family: "InknutAntiqua-Bold", sans-serif;
  font-size: 14px;
  letter-spacing: 0.01em;
  font-weight: 700;
  position: absolute;
  left: 883px;
  top: 284px;
  width: 10px;
  height: 12px;
}
._34-00 {
  color: #1f4c78;
  text-align: right;
  font-family: "InknutAntiqua-Bold", sans-serif;
  font-size: 14px;
  letter-spacing: 0.01em;
  font-weight: 700;
  position: absolute;
  left: 900px;
  top: 284px;
  width: 71px;
  height: 15px;
}

.tel-fonos {
    color: #000000;
    text-align: center;
    font-family: "Inder-Regular", sans-serif;
    font-size: 10px;
    letter-spacing: 0.01em;
    font-weight: 400;
    position: absolute;
    left: 416px;
    top: calc(69px + 22px);
    height: 15px;
    width: 320px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
._503 {
  color: #1f4c78;
  text-align: center;
  font-family: "Inder-Regular", sans-serif;
  font-size: 11px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
  left: 465px; /* Manteniendo espacio */
  top: 72px;
  height: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

._555-1312-7777-0000-2233-445 {
  color: #1f4c78;
  text-align: center; /* Asegura que el texto esté centrado */
  font-family: "Inder-Regular", sans-serif;
  font-size: 11px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
  left: 490px; 
  top: 72px;
  height: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.transportes-sv-hotmail-com {
  color: #1f4c78;
  text-align: center;
  font-family: "Inder-Regular", sans-serif;
  font-size: 11px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
  left: 45px;
  top: 86px;
  width: 177px;
  height: 20px;
}
.eduardo-antonio-marroquin-orellana2 {
  color: #1f4c78;
  text-align: left;
  font-family: "Inder-Regular", sans-serif;
  font-size: 14px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
  left: 720px;
  top: 156px;
  height: 18px;
}
.rectangle-6 {
  background: #ffff00;
  width: 121px;
  height: 27px;
  position: absolute;
  left: 850px;
  top: 124px;
}
.sv-000000 {
  color: #1f4c78;
  text-align: left;
  font-family: "InknutAntiqua-Regular", sans-serif;
  font-size: 12px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
  left: 870px;
  top: 130px;
  width: 86px;
  height: 24px;
}
._0511-211166-002-5 {
  color: #1f4c78;
  text-align: left;
  font-family: "Inder-Regular", sans-serif;
  font-size: 14px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
  left: 788px;
  top: 182px;
  width: 206px;
  height: 19px;
}
.c-000000 {
  color: #1f4c78;
  text-align: left;
  font-family: "Inder-Regular", sans-serif;
  font-size: 14px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
  left: 787px;
  top: 203px;
  width: 201px;
  height: 17px;
}
.re-000-000 {
  color: #1f4c78;
  text-align: left;
  font-family: "Inder-Regular", sans-serif;
  font-size: 14px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
  left: 788px;
  top: 223px;
  width: 204px;
  height: 19px;
}
.line-50 {
  margin-top: -1px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px 0 0 0;
  width: 310px;
  height: 0px;
  position: absolute;
  left: 662px;
  top: 261px;
  transform-origin: 0 0;
  transform: rotate(0.188deg) scale(1, 1);
}
.line-51 {
  margin-top: -1px;
  border-style: solid;
  border-color: rgba(0, 0, 0, 0);
  border-width: 1px 0 0 0;
  width: 19px;
  height: 0px;
  position: absolute;
  left: 727px;
  top: 242px;
  transform-origin: 0 0;
  transform: rotate(90deg) scale(1, 1);
}
.line-52 {
  margin-top: -1px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px 0 0 0;
  width: 19px;
  height: 0px;
  position: absolute;
  left: 766px;
  top: 242px;
  transform-origin: 0 0;
  transform: rotate(90deg) scale(1, 1);
}
.line-53 {
  margin-top: -1px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px 0 0 0;
  width: 21px;
  height: 0px;
  position: absolute;
  left: 766px;
  top: 261px;
  transform-origin: 0 0;
  transform: rotate(90deg) scale(1, 1);
}
.line-54 {
  margin-top: -1px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px 0 0 0;
  width: 20px;
  height: 0px;
  position: absolute;
  left: 825px;
  top: 282px;
  transform-origin: 0 0;
  transform: rotate(90deg) scale(1, 1);
}
.line-55 {
  margin-top: -1px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px 0 0 0;
  width: 22px;
  height: 0px;
  position: absolute;
  left: 882px;
  top: 281px;
  transform-origin: 0 0;
  transform: rotate(90deg) scale(1, 1);
}
.div2 {
  color: #1f4c78;
  text-align: right;
  font-family: "InknutAntiqua-Bold", sans-serif;
  font-size: 14px;
  letter-spacing: 0.01em;
  font-weight: 700;
  position: absolute;
  left: 883px;
  top: 283px;
  width: 21px;
  height: 19px;
}


.valor {
  color: #000000;
  text-align: left;
  font-family: "InknutAntiqua-Bold", sans-serif;
  font-size: 10px;
  letter-spacing: 0.01em;
  font-weight: 700;
  position: absolute;
  left: 735px;
  top: 322px;
  width: 49px;
  height: 18px;
}
.peso-bruto {
  color: #000000;
  text-align: left;
  font-family: "InknutAntiqua-Bold", sans-serif;
  font-size: 10px;
  letter-spacing: 0.01em;
  font-weight: 700;
  position: absolute;
  left: 861px;
  top: 323px;
  width: 86px;
  height: 21px;
}
.line-56 {
  margin-top: -1px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px 0 0 0;
  width: 13px;
  height: 0px;
  position: absolute;
  left: 34px;
  top: 645px;
  transform-origin: 0 0;
  transform: rotate(-90deg) scale(1, 1);
}
.line-57 {
  margin-top: -1px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px 0 0 0;
  width: 699px;
  height: 0px;
  position: absolute;
  left: 987px;
  top: 728px;
  transform-origin: 0 0;
  transform: rotate(-90deg) scale(1, 1);
}
.el-salvador {
  color: #1f4c78;
  text-align: center;
  font-family: "Inder-Regular", sans-serif;
  font-size: 14px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
  left: 739px;
  top: 242px;
  width: 233px;
  height: 20px;
}
.costa-rica {
  color: #1f4c78;
  text-align: center;
  font-family: "Inder-Regular", sans-serif;
  font-size: 14px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
  left: 735px;
  top: 262px;
  width: 233px;
}
.bs4 {
  color: #1f4c78;
  text-align: center;
  font-family: "Inder-Regular", sans-serif;
  font-size: 12px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
  left: 213px;
  top: 344px;
  width: 30px;
  height: 15px;
}
.pts {
  color: #1f4c78;
  text-align: center;
  font-family: "Inder-Regular", sans-serif;
  font-size: 12px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
  left: 210px;
  top: 547px;
  width: 36px;
  height: 21px;
}
.bs5 {
  color: #1f4c78;
  text-align: center;
  font-family: "Inder-Regular", sans-serif;
  font-size: 12px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
  left: 213px;
  top: 524px;
  width: 30px;
  height: 15px;
}
.bs6 {
  color: #1f4c78;
  text-align: center;
  font-family: "Inder-Regular", sans-serif;
  font-size: 12px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
  left: 213px;
  top: 471px;
  width: 30px;
  height: 15px;
}
.bs7 {
  color: #1f4c78;
  text-align: center;
  font-family: "Inder-Regular", sans-serif;
  font-size: 12px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
  left: 213px;
  top: 442px;
  width: 30px;
  height: 15px;
}
.bs8 {
  color: #1f4c78;
  text-align: center;
  font-family: "Inder-Regular", sans-serif;
  font-size: 12px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
  left: 213px;
  top: 418px;
  width: 30px;
  height: 15px;
}
.f-12345678-dhys {
  color: #1f4c78;
  text-align: center;
  font-family: "Inder-Regular", sans-serif;
  font-size: 12px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
left: 121px;
  top: 344px;
  width: 140px;
  height: 15px;
  transform: translateX(-50%);
}
.f-12345678-dhys2 {
  color: #1f4c78;
  text-align: center;
  font-family: "Inder-Regular", sans-serif;
  font-size: 12px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
   left: 121px;
  top: 495px;
   width: 140px;
  height: 15px;
  transform: translateX(-50%);
}
.f-12345678-dhys3 {
  color: #1f4c78;
  text-align: center;
  font-family: "Inder-Regular", sans-serif;
  font-size: 12px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
   left: 121px;
  top: 471px;
   width: 140px;
  height: 15px;
  transform: translateX(-50%);
}
.f-12345678-dhys4 {
  color: #1f4c78;
  text-align: center;
  font-family: "Inder-Regular", sans-serif;
  font-size: 12px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
  left: 121px;
  top: 444px;
   width: 140px;
  height: 15px;
  transform: translateX(-50%);
}
.f-12345678-dhys5 {
  color: #1f4c78;
  text-align: center;
  font-family: "Inder-Regular", sans-serif;
  font-size: 12px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
  left: 121px;
  top: 416px;
   width: 140px;
  height: 15px;
  transform: translateX(-50%);
}
.f-12345678-dhys6 {
  color: #1f4c78;
  text-align: center;
  font-family: "Inder-Regular", sans-serif;
  font-size: 12px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
   left: 121px;
  top: 392px;
   width: 140px;
  height: 15px;
  transform: translateX(-50%);
}
.f-12345678-dhys7 {
  color: #1f4c78;
  text-align: center;
  font-family: "Inder-Regular", sans-serif;
  font-size: 12px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
  left: 121px;
  top: 368px;
  width: 140px;
  height: 15px;
  transform: translateX(-50%);
}
.f-12345678-dhys8 {
  color: #1f4c78;
  text-align: center;
  font-family: "Inder-Regular", sans-serif;
  font-size: 12px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
   left: 121px;
  top: 545px;
   width: 140px;
  height: 15px;
  transform: translateX(-50%);
}
.f-12345678-dhys9 {
  color: #1f4c78;
  text-align: center;
  font-family: "Inder-Regular", sans-serif;
  font-size: 12px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
   left: 121px;
  top: 521px;
   width: 140px;
  height: 15px;
  transform: translateX(-50%);
}
._4539 {
  color: #1f4c78;
  text-align: center;
  font-family: "Inder-Regular", sans-serif;
  font-size: 12px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
  left: 275px;
  top: 344px;
  transform: translateX(-50%);
}
._90 {
  color: #1f4c78;
  text-align: center;
  font-family: "Inder-Regular", sans-serif;
  font-size: 12px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
  left: 275px;
  top: 371px;
  transform: translateX(-50%);
}
._7 {
  color: #1f4c78;
  text-align: center;
  font-family: "Inder-Regular", sans-serif;
  font-size: 12px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
 left: 275px;
  top: 392px;
  transform: translateX(-50%);
}
._72 {
  color: #1f4c78;
  text-align: center;
  font-family: "Inder-Regular", sans-serif;
  font-size: 12px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
  left: 275px;
  top: 418px;
  transform: translateX(-50%);
}
._3456 {
  color: #1f4c78;
  text-align: center;
  font-family: "Inder-Regular", sans-serif;
  font-size: 12px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
  left: 275px;
  top: 520px;
  transform: translateX(-50%);
}
._34562 {
  color: #1f4c78;
  text-align: center;
  font-family: "Inder-Regular", sans-serif;
  font-size: 12px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
  left: 275px;
  top: 495px;
  transform: translateX(-50%);
}
._34563 {
  color: #1f4c78;
  text-align: center;
  font-family: "Inder-Regular", sans-serif;
  font-size: 12px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
  left: 275px;
  top: 471px;
  transform: translateX(-50%);
}
._34564 {
  color: #1f4c78;
  text-align: center;
  font-family: "Inder-Regular", sans-serif;
  font-size: 12px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
  left: 275px;
  top: 444px;
  transform: translateX(-50%);
}
._34565 {
  color: #1f4c78;
  text-align: center;
  font-family: "Inder-Regular", sans-serif;
  font-size: 12px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
  left: 275px;
  top: 546px;
  transform: translateX(-50%);
}
.alimentos {
  color: #1f4c78;
  text-align: center;
  font-family: "Inder-Regular", sans-serif;
  font-size: 12px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
  left: 309px;
  top: 344px;
}
.vasos-plasticos {
  color: #1f4c78;
  text-align: center;
  font-family: "Inder-Regular", sans-serif;
  font-size: 12px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
  left: 309px;
  top: 368px;
}
.manufacturas-de-cart-n {
  color: #1f4c78;
  text-align: center;
  font-family: "Inder-Regular", sans-serif;
  font-size: 12px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
  left: 309px;
  top: 394px;
}
.alimentos2 {
  color: #1f4c78;
  text-align: center;
  font-family: "Inder-Regular", sans-serif;
  font-size: 12px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
  left: 309px;
  top: 420px;
}
.vasos-plasticos2 {
  color: #1f4c78;
  text-align: center;
  font-family: "Inder-Regular", sans-serif;
  font-size: 12px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
  left: 309px;
  top: 442px;
}
.manufacturas-de-cart-n2 {
  color: #1f4c78;
  text-align: center;
  font-family: "Inder-Regular", sans-serif;
  font-size: 12px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
  left: 309px;
  top: 470px;
}
.alimentos3 {
  color: #1f4c78;
  text-align: center;
  font-family: "Inder-Regular", sans-serif;
  font-size: 12px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
  left: 309px;
  top: 495px;
}
.vasos-plasticos3 {
  color: #1f4c78;
  text-align: center;
  font-family: "Inder-Regular", sans-serif;
  font-size: 12px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
  left: 309px;
  top: 523px;
}
.manufacturas-de-cart-n3 {
  color: #1f4c78;
  text-align: center;
  font-family: "Inder-Regular", sans-serif;
  font-size: 12px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
  left: 309px;
  top: 548px;
}
._21923 {
  color: #1f4c78;
  text-align: center;
  font-family: "Inder-Regular", sans-serif;
  font-size: 12px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
  left: 274px;
  top: 573px;
  transform: translateX(-50%);
}
._28-200-00 {
  color: #1f4c78;
  text-align: right;
  font-family: "Inder-Regular", sans-serif;
  font-size: 12px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
  left: 687px;
  top: 345px;
  width: 141px;
  height: 23px;
}
._1-800-00 {
  color: #1f4c78;
  text-align: right;
  font-family: "Inder-Regular", sans-serif;
  font-size: 12px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
  left: 684px;
  top: 368px;
  width: 144px;
  height: 23px;
}
._1-900-00 {
  color: #1f4c78;
  text-align: right;
  font-family: "Inder-Regular", sans-serif;
  font-size: 12px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
  left: 687px;
  top: 394px;
  width: 141px;
  height: 23px;
}
._28-200-002 {
  color: #1f4c78;
  text-align: right;
  font-family: "Inder-Regular", sans-serif;
  font-size: 12px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
  left: 687px;
  top: 496px;
  width: 141px;
}
._28-200-003 {
  color: #1f4c78;
  text-align: right;
  font-family: "Inder-Regular", sans-serif;
  font-size: 12px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
  left: 687px;
  top: 549px;
  width: 141px;
}
._28-200-004 {
  color: #1f4c78;
  text-align: right;
  font-family: "Inder-Regular", sans-serif;
  font-size: 12px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
  left: 687px;
  top: 522px;
  width: 141px;
}
._28-200-005 {
  color: #1f4c78;
  text-align: right;
  font-family: "Inder-Regular", sans-serif;
  font-size: 12px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
  left: 687px;
  top: 471px;
  width: 141px;
}
._28-200-006 {
  color: #1f4c78;
  text-align: right;
  font-family: "Inder-Regular", sans-serif;
  font-size: 12px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
  left: 687px;
  top: 442px;
  width: 141px;
  height: 23px;
}
._28-200-007 {
  color: #1f4c78;
  text-align: right;
  font-family: "Inder-Regular", sans-serif;
  font-size: 12px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
  left: 688px;
  top: 417px;
  width: 141px;
  height: 23px;
}
._31-900-00 {
  color: #003366;
  text-align: right;
  font-family: "InknutAntiqua-Bold", sans-serif;
  font-size: 12px;
  letter-spacing: 0.01em;
  font-weight: 700;
  position: absolute;
  left: 687px;
  top: 576px;
  width: 141px;
}
._18000-00 {
  color: #1f4c78;
  text-align: center;
  font-family: "Inder-Regular", sans-serif;
  font-size: 12px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
  left: 834px;
  top: 345px;
  width: 135px;
}
._900-00 {
  color: #1f4c78;
  text-align: center;
  font-family: "Inder-Regular", sans-serif;
  font-size: 12px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
  left: 834px;
  top: 368px;
  width: 135px;
}
._900-002 {
  color: #1f4c78;
  text-align: center;
  font-family: "Inder-Regular", sans-serif;
  font-size: 12px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
  left: 834px;
  top: 394px;
  width: 135px;
}
._1400 {
  color: #1f4c78;
  text-align: center;
  font-family: "Inder-Regular", sans-serif;
  font-size: 12px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
  left: 834px;
  top: 417px;
  width: 135px;
}
._14002 {
  color: #1f4c78;
  text-align: center;
  font-family: "Inder-Regular", sans-serif;
  font-size: 12px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
  left: 834px;
  top: 549px;
  width: 135px;
}
._14003 {
  color: #1f4c78;
  text-align: center;
  font-family: "Inder-Regular", sans-serif;
  font-size: 12px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
  left: 834px;
  top: 522px;
  width: 135px;
}
._14004 {
  color: #1f4c78;
  text-align: center;
  font-family: "Inder-Regular", sans-serif;
  font-size: 12px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
  left: 834px;
  top: 496px;
  width: 135px;
}
._14005 {
  color: #1f4c78;
  text-align: center;
  font-family: "Inder-Regular", sans-serif;
  font-size: 12px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
  left: 834px;
  top: 471px;
  width: 135px;
}
._14006 {
  color: #1f4c78;
  text-align: center;
  font-family: "Inder-Regular", sans-serif;
  font-size: 12px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
  left: 834px;
  top: 446px;
  width: 135px;
}
._28-800-00 {
  color: #003366;
  text-align: center;
  font-family: "InknutAntiqua-Bold", sans-serif;
  font-size: 12px;
  letter-spacing: 0.01em;
  font-weight: 700;
  position: absolute;
  left: 834px;
  top: 576px;
  width: 135px;
}
.son-4-636-bultos-conteniendo-48-pallets {
  color: #1f4c78;
  text-align: right;
  font-family: "Inder-Regular", sans-serif;
  font-size: 12px;
  letter-spacing: 0.01em;
  font-weight: 400;
  position: absolute;
  left: 39px;
  top: 630px;
}
.flete2{
  top: 284px;
  
}
 .t1 {
	transform-origin: bottom left;
	z-index: 2;
	position: absolute;
	white-space: normal; /* Permite que el texto se ajuste */
	overflow: visible; /* Cambia a hidden si no quieres que el texto desborde */
	line-height: 1;
	
  transform: translateX(-10%);
  text-align: center;
}
  .t2 {
	transform-origin: bottom left;
	z-index: 2;
	position: absolute;
	white-space: normal; /* Permite que el texto se ajuste */
	overflow: visible; /* Cambia a hidden si no quieres que el texto desborde */
	line-height: 1;
  text-align: center;
}
  .blue-text {
  color: #1f4c78;
}
.p1{
  font-size: 10px;
  color: #000000;
  font-weight: 700;
}

   </style>
  <title>Document</title>
</head>
<body>
  <div class="frame-1">
    <div class="flete">FLETE</div>
    
    <div class="seguro">SEGURO</div>
    
    <div class="pais-origen">PAIS ORIGEN</div>
    <div class="pais-destino">PAIS DESTINO</div>
    <div class="furgon-placa">FURGON PLACA</div>
    <div class="line-1"></div>
    <div class="line-4"></div>
    <div class="line-3"></div>
    <div class="line-6"></div>
    <div class="line-11"></div>
    <div class="line-7"></div>
    <div class="line-8"></div>
    <div class="line-9"></div>
    <div 
  class="transportes-el-salvador t2" 
  style="top: 31px;"
>
  ${data?.transportista.toUpperCase()}
</div>
    <div class="carta-de-porte-no">CARTA DE PORTE No.</div>
    <div
  class="kilometro-20-5-calle-poniente-y-25-avenida-sur-san-jose-del-monte-interseccion-las-ca-as-1"
  style="top: ${data?.transportista.length > 27 ? '69px' : '53px'};"
>
  ${data?.dTransportista}
</div>
    <div class="_001">${data?.nCartaPorte}</div>
    <div class="cs-cajas-bs-bolsas-pts-paquetes-u-unidades-sa-sacos-ro-rollos">
      CS= CAJAS, BS= BOLSAS, PTS= PAQUETES, U=UNIDADES, SA= SACOS, RO=ROLLOS
    </div>
    <div class="eduardo-antonio-marroquin-orellana">
    ${data?.piloto} <br /> <span class="p1">PILOTO</span>
      <br />
    </div>
    <div class="line-10"></div>
    <div class="line-15"></div>
    <div class="line-12"></div>
    <div class="lugar-y-fecha-de-expedici-n">LUGAR Y FECHA DE EXPEDICIÓN</div>
    <div class="codigo-de-transportista">CODIGO DE TRANSPORTISTA</div>
    <div class="piloto">PILOTO</div>
    <div class="licencia-piloto">LICENCIA PILOTO</div>
    <div class="cabezal-placa">CABEZAL PLACA</div>
    <div class="san-salvador">${data.lugarExpedicion}</div>
    <div class="industrias-alas-verdes-s-a-de-c-v">
    ${data.exportador}
    </div>
    <div
      class="km-34-boulevard-del-ejercito-nacional-y-10-ave-norte-barrio-la-ceiba"
    >
    ${data.dexportador}
    </div>
    <div class="industrias-de-costa-rica">${data?.consignatario}</div>
    <div class="avenida-san-juan-y-calle-sur-no-2034-san-jose-costa-rica">
       ${data?.direccionConsignatario}
    </div>
    <div class="_20-de-diciembre-de-2020">${
      data?.fechaExpedicionFormateada
    }</div>
    <div class="consignatario">CONSIGNATARIO</div>
    <div class="direcci-n-del-consignatario">DIRECCIÓN DEL CONSIGNATARIO</div>
    <div class="direcci-n-del-exportador">DIRECCIÓN DEL EXPORTADOR</div>
    <div class="exportador">EXPORTADOR</div>
    <img
      class="captura-de-pantalla-20250104-104626-1"
      src="data:image/png;base64,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" alt=""
    />
    <div class="line-16"></div>
    <div class="line-13"></div>
    <div class="line-17"></div>
    <div class="line-18"></div>
    <div class="line-19"></div>
    <div class="line-20"></div>
    <div class="rectangle-5"></div>
    <div class="rectangle-7"></div>
    <div class="line-21"></div>
    <div class="line-27"></div>
    <div class="line-28"></div>
    <div class="line-29"></div>
    <div class="line-30"></div>
    <div class="line-31"></div>
    <div class="bs">${data?.claseBultos7}</div>
    <div class="line-32"></div>
    <div class="line-33"></div>
    <div class="line-34"></div>
    <div class="line-35"></div>
    <div class="line-36"></div>
    <div class="line-37"></div>
    <div class="line-22"></div>
    <div class="line-23"></div>
    <div class="bs2">${data?.claseBultos2}</div>
    <div class="bs3">${data?.claseBultos3}</div>
    <div class="line-25"></div>
    <div class="line-24"></div>
    <div class="line-26"></div>
    <div class="facturas">FACTURAS</div>
    <div class="no-de-bultos">No. De Bultos</div>
    <div class="contenido">CONTENIDO</div>
    <div class="totales">TOTALES</div>
    <div class="piloto2"></div>
    <div class="piloto3">SELLO</div>
    <div class="observaciones">OBSERVACIONES</div>
    <div class="line-38"></div>
    <div class="line-39"></div>
    <div class="line-40"></div>
    <div class="line-44"></div>
    <div class="line-41"></div>
    <div class="line-42"></div>
    <div class="line-43"></div>
    <div class="line-45"></div>
    <div class="line-48"></div>
    <div class="line-49"></div>
    <div class="div flete2">
    ${data?.flete}  
      <br />
    </div>
    
    <div class="_34-00">${data?.seguro}</div>

    <div 
  class="tel-fonos t1"
  style="top: ${data?.transportista.length > 27 ? '95px' : '80px'};"
>
  Teléfonos <span class="blue-text">${data?.areaPais}</span> 
  <span class="blue-text">${data?.telefono}</span><br/>
  <span class="blue-text">${data?.correo}</span>
</div>
  
    <div class="eduardo-antonio-marroquin-orellana2">
    ${data?.piloto}
    
      <br />
    </div>
    <div class="rectangle-6"></div>
    <div class="sv-000000">${data?.codigoTransportista}</div>
    <div class="_0511-211166-002-5">${data?.licenciaPiloto}</div>
    <div class="c-000000">
    ${data?.cabezalPlaca}
      <br />
    </div>
    <div class="re-000-000">${data?.furgonPlaca}</div>
    <div class="line-50"></div>
    <div class="line-51"></div>
    <div class="line-52"></div>
    <div class="line-53"></div>
    <div class="line-54"></div>
    <div class="line-55"></div>
    <div class="valor">VALOR</div>
    <div class="peso-bruto">PESO BRUTO</div>
    <div class="line-56"></div>
    <div class="line-57"></div>
    <div class="el-salvador">
    ${data?.paisOrigen}
      <br />
    </div>
    <div class="costa-rica">${data?.paisDestino}</div>
    <div class="bs4">${data?.claseBultos}</div>
    <div class="pts">${data?.claseBultos9}</div>
    <div class="bs5">${data?.claseBultos8}</div>
    <div class="bs6">${data?.claseBultos6}</div>
    <div class="bs7">${data?.claseBultos5}</div>
    <div class="bs8">${data?.claseBultos4}</div>
    <div class="f-12345678-dhys">${data?.factura}</div>
    <div class="f-12345678-dhys2">${data?.factura7}</div>
    <div class="f-12345678-dhys3">${data?.factura6}</div>
    <div class="f-12345678-dhys4">${data?.factura5}</div>
    <div class="f-12345678-dhys5">${data?.factura4}</div>
    <div class="f-12345678-dhys6">${data?.factura3}</div>
    <div class="f-12345678-dhys7">${data?.factura2}</div>
    <div class="f-12345678-dhys8">${data?.factura9}</div>
    <div class="f-12345678-dhys9">${data?.factura8}</div>
    <div class="_4539">${data?.NoBulto}</div>
    <div class="_90">${data?.NoBulto2}</div>
    <div class="_7">${data?.NoBulto3}</div>
    <div class="_72">${data?.NoBulto4}</div>
    <div class="_3456">${data?.NoBulto5}</div>
    <div class="_34562">${data?.NoBulto6}</div>
    <div class="_34563">${data?.NoBulto7}</div>
    <div class="_34564">${data?.NoBulto8}</div>
    <div class="_34565">${data?.NoBulto9}</div>
    <div class="alimentos">${data?.conteProducto}</div>
    <div class="vasos-plasticos">
    ${data?.conteProducto2}
      <br />
    </div>
    <div class="manufacturas-de-cart-n">
    ${data?.conteProducto3}
      <br />
    </div>
    <div class="alimentos2">${data?.conteProducto4}</div>
    <div class="vasos-plasticos2">
    ${data?.conteProducto5}
      <br />
    </div>
    <div class="manufacturas-de-cart-n2">
    ${data?.conteProducto6}
      <br />
    </div>
    <div class="alimentos3">${data?.conteProducto7}</div>
    <div class="vasos-plasticos3">
    ${data?.conteProducto8}
      <br />
    </div>
    <div class="manufacturas-de-cart-n3">
    ${data?.conteProducto9}
      <br />
    </div>
    <div class="_21923">${data.cBultos}</div>
    <div class="_28-200-00">${data?.valorMercaderia}</div>
    <div class="_1-800-00">${data?.valorMercaderia2}</div>
    <div class="_1-900-00">
    ${data?.valorMercaderia3}
      <br />
    </div>
    <div class="_28-200-002">${data?.valorMercaderia7}</div>
    <div class="_28-200-003">${data?.valorMercaderia9}</div>
    <div class="_28-200-004">${data?.valorMercaderia8}</div>
    <div class="_28-200-005">${data?.valorMercaderia6}</div>
    <div class="_28-200-006">${data?.valorMercaderia5}</div>
    <div class="_28-200-007">${data?.valorMercaderia4}</div>
    <div class="_31-900-00">${data?.valorTotal}</div>
    <div class="_18000-00">${data?.pesoBruto}</div>
    <div class="_900-00">${data?.pesoBruto2}</div>
    <div class="_900-002">${data?.pesoBruto3}</div>
    <div class="_1400">${data?.pesoBruto4}</div>
    <div class="_14002">${data?.pesoBruto9}</div>
    <div class="_14003">${data?.pesoBruto8}</div>
    <div class="_14004">${data?.pesoBruto7}</div>
    <div class="_14005">${data?.pesoBruto6}</div>
    <div class="_14006">${data?.pesoBruto5}</div>
    <div class="_28-800-00">${data?.pesoBrutoTotal}</div>
    <div class="son-4-636-bultos-conteniendo-48-pallets">
    ${data?.observaciones}
      <br />
    </div>
  </div>
  
</body>
</html>
  `;
}
